import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/vercel/path0/packages/web/components/layout/Navbar.tsx");
